import React from 'react';
import { Heading, Loader } from '@thd-olt-component-react/core-ui';
import { string, number } from 'prop-types';
import { KitchenCollectionDataModel } from '../KitchenCollectionDataModel';

export const KitchenCollectionSectionHeading = ({
  sectionTitle,
  productCount
}) => {
  return (
    <Heading>
      <div data-testid="kitchen-product-heading">
        {sectionTitle}
        <span
          className="kitchen-collection__product-count"
        >
          {typeof (productCount) === 'number' ? `(${productCount})` : <Loader active small />}
        </span>
      </div>
    </Heading>
  );
};

KitchenCollectionSectionHeading.displayName = 'KitchenCollectionSectionHeading';

KitchenCollectionSectionHeading.dataModel = KitchenCollectionDataModel;

KitchenCollectionSectionHeading.propTypes = {
  sectionTitle: string.isRequired,
  productCount: number
};

KitchenCollectionSectionHeading.defaultProps = {
  productCount: null
};